//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { CSSProperties } from 'react';
import { Container } from '@mui/material';
import styled from '@emotion/styled';

type TitleBarProps = {
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
  style?: CSSProperties;
};

const TitleBar = ({ children, loading = false, className, ...props }: TitleBarProps) => {
  return (
    <TitleBarContainer isLoading={loading} className={className} {...props}>
      <Container>{children}</Container>
    </TitleBarContainer>
  );
};

export default TitleBar;

const TitleBarContainer = styled.div<{ isLoading: boolean }>`
  && {
    min-height: 69px;
    background: ${({ theme }) => theme.palette.background.paper};
    display: flex;
    align-items: center;
    padding: 20px 0;
    margin-bottom: 25px;
    border-bottom: ${({ theme }) => (theme.palette.mode === 'light' ? `1px solid ${theme.palette.divider}` : 'none')};
    ${({ isLoading }) => isLoading && `opacity: 0.2;`}

    .MuiButton-root {
      margin-top: ${({ theme }) => theme.spacing(-1.33)};
      margin-bottom: ${({ theme }) => theme.spacing(-1.33)};
    }

    ${({ theme }) => theme.customOverrides?.TitleBar}
  }
`;
